module.exports = __webpack_public_path__ + "media/images/Amsale-Bespoke-Bridal-2691490a.webp";